import { FirestoreDataConverter } from "firebase/firestore";
import moment from "moment";
import Transacao from "../models/transacao";
import BaseDb from "./baseDb";

export default class TransacaoDb extends BaseDb<
  Transacao,
  { usuarioId: string; transacaoId: string }
> {
  _path: string = "usuarios/usuarioId/transacoes/transacaoId";
  getConverter(): FirestoreDataConverter<Transacao> {
    return {
      fromFirestore: (snapshot, _options) =>
        new Transacao({
          dataTransacao: moment(snapshot.get("dataTransacao").toDate()),
          classeAtivo: snapshot.get("classeAtivo"),
          daytradeSwingtrade: snapshot.get("daytradeSwingtrade"),
          codigoAtivo: snapshot.get("codigoAtivo"),
          mercado: snapshot.get("mercado"),
          valorVendido: snapshot.get("valorVendido"),
          resultado: snapshot.get("resultado"),
          irrf: snapshot.get("irrf"),
          posicao: snapshot.get("posicao"),
          operacao: snapshot.get("operacao"),
        }),
      toFirestore: (_transacao: Transacao) => {
        throw new Error("Não é possível criar uma transacao");
      },
    };
  }
}
